export const sideNavEnumObject = {
  drawerWidth: 247,
}
export const complianceObject = {
    fileSize : 1048576
    // 1MB = 1024 * 1024 = 1048576
  }
export const dateObject = {
maxDate:'9999-05-31'
}
export const minDate = '1950-01-01'
export const commonObject = {
  businessType:2
}

  export const drawerWidthEnum = {
    minWidth: 104,
    maxWidth: 270
  }
export const dutyTypeEnum = {
  ride: 1,
  rentalBaseRate: 2,
  rentalExtraKm: 3,
  outstation: 4
};

export const rateCardFiltersEnum = {
  cityType: "cityType",
  dutyType: "dutyType",
  carType: "carType"
}

export const dutyTypeData = [
  // { name: "Ride / Airport Transfer", id: 1 },
  { name: "Rental", id: 3 },
  { name: "Outstation", id: 9 },
];

export const nightAllowanceTime ={
  start:21,
  end:6
} 

export const businessTypeData = {
  coorporate:'0',
  public:'1',
  both:'2'
}

export const vehicelPriority = 
  [
  { value: '1', label: 'Priority 1' },
  { value: '2', label: 'Priority 2' },
  { value: '3', label: 'Priority 3' },
  { value: '4', label: 'Priority 4' },
]

export const tripEnumObject = {
  oneWay: '1',
  rental: '3',
  airport: '4',
  outStationRound:'9',
  outStation:'8',
}
export const enumValue = {
  zero:'0'
}
export const toastObject = {
  infoAutoClose: 5000,
  countryCode:'+91'
}
export const fileSizeObject = {
  fileSize: 1048576,
  // 1MB = 1024 * 1024 = 1048576
};